/**
 * SalesIcon — pictograma „Vânzări" (sidebar / nav).
 *
 * Sursă: `pictograme/New folder (3)/SVG/Asset 75.svg` — bar chart cu săgeată
 * up pe coloana cea mai înaltă (metaforă vizuală pentru creștere vânzări).
 * Inline ca React component → permite colorare via `currentColor` și
 * activarea/inactiv state-ul în nav fără hack-uri CSS.
 *
 * Stroke-width adaptat (10) pentru paritate vizuală cu Lucide icons în
 * slot-uri h-5 w-5 (ratio 10/159 ≈ 6.3%, similar cu Lucide 2/24 ≈ 8.3%).
 */

interface SalesIconProps {
  className?: string;
  size?: number;
  'aria-hidden'?: boolean;
}

export function SalesIcon({
  className = '',
  size = 20,
  'aria-hidden': ariaHidden,
}: SalesIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 159.17 159.17"
      width={size}
      height={size}
      className={className}
      role={ariaHidden ? undefined : 'img'}
      aria-label={ariaHidden ? undefined : 'Vânzări'}
      aria-hidden={ariaHidden}
    >
      <polyline
        points="135.28 157.35 135.28 46.46 157.35 46.46 120.4 1.83 83.45 46.46 105.51 46.46 105.51 157.35 83.45 157.35 83.45 77.82 53.67 77.82 53.67 157.35 31.61 157.35 31.61 109.19 1.83 109.19 1.83 157.35"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
    </svg>
  );
}
